import type { JSX } from "react";
import { FC } from "react";
import { P1 } from "../atoms/Paragraph";
import styled from "styled-components";
import { CheckedCircle } from "../atoms/CheckedCircle";
import ReactDOMServer from "react-dom/server";
import { tablet } from "components/templates/Breakpoints";

export const CheckList: FC<
  React.PropsWithChildren<{
    pt?: string;
    pb?: string;
    items: (string | string[] | JSX.Element)[];
    textColor?: string;
    iconColor?: string;
    backgroundColor?: string;
    columns?: number;
    textBold?: boolean;
    checklistTitle?: string;
  }>
> = ({
  pt = "1.5rem",
  pb,
  items,
  textColor = "#956AFF",
  iconColor,
  backgroundColor,
  columns = 1,
  textBold,
  checklistTitle,
}) => {
  return (
    <>
      {checklistTitle ? <ListTitle>{checklistTitle}</ListTitle> : null}
      <UL pt={pt} pb={pb} columns={columns}>
        {items.map((listItem) => {
          return (
            <LI
              key={
                Array.isArray(listItem)
                  ? listItem[0]
                  : typeof listItem === "string"
                    ? listItem
                    : ReactDOMServer.renderToStaticMarkup(listItem)
              }
            >
              <Flex>
                <IconContainer>
                  <CheckedCircle color={iconColor} backgroundColor={backgroundColor} />
                </IconContainer>
                {Array.isArray(listItem) || typeof listItem === "string" ? (
                  getItem(listItem, textColor, textBold)
                ) : (
                  <>{listItem}</>
                )}
              </Flex>
            </LI>
          );
        })}
      </UL>
    </>
  );
};

const getItem = (listItem: string | string[], color?: string, textBold?: boolean) => {
  if (Array.isArray(listItem) && listItem.length) {
    return (
      <P1 pt="0" color={color}>
        <strong>{listItem[0]}</strong> {listItem[1]}
      </P1>
    );
  }
  return (
    <P1 pt="0" bold={textBold} style={{ width: "25rem" }} color={color}>
      {listItem}
    </P1>
  );
};

const UL = styled.ul<{ pt?: string; pb?: string; columns?: number }>`
  ${(p) => (p.pt ? `padding-top: ${p.pt};` : null)}
  ${(p) => (p.pb ? `padding-bottom: ${p.pt};` : null)}
  ${tablet} {
    columns: 1;
  }
  ${(p) => (p.columns ? `columns: ${p.columns}` : null)}
`;

const LI = styled.li`
  font-size: 1.25rem;
  line-height: 2rem;
  letter-spacing: 0.075rem;
  margin-bottom: 1.5rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Flex = styled.div`
  display: flex;
`;

const IconContainer = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
  margin-right: 1.5rem;
  margin-top: 0.3rem;
`;

const ListTitle = styled(P1)`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0.075rem;
  margin-bottom: 1.5rem;
`;
